import { Component, ViewChild, AfterViewInit, OnDestroy, } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { Router } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MSMEParticipantListForInvoice } from '../../../../../shared/models/MSMEParticipantListForInvoice';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-updatepaymentdetails',
  templateUrl: './updatepaymentdetails.component.html',
  styleUrl: './updatepaymentdetails.component.css'
})
export class UpdatepaymentdetailsComponent implements AfterViewInit, OnDestroy {
  eventId: any = sessionStorage.getItem('EventId');
  invoiceStatusForm: FormGroup;
  paymentDetailsForm: FormGroup;
  statusList: any[] = [];
  paymentMode: any[] = [];
  showSection = false;
  msmeList: any[] = [];
  unVerified: number = 0;
  disabledStatusValues: any[] = [];
  showUpdate: boolean = false;

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  dataSource!: MatTableDataSource<MSMEParticipantListForInvoice>
  displayedColumns: string[] = ['Sr.No', 'UdyamRegistrationNumber', 'ParticipantName', 'Designation', 'MobileNumber', 'EmailId']
  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  allrecord: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  mobile = sessionStorage.getItem('mobile');
  DtoPagination =
    {
      "EventId": this.eventId,
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }
  maxDate: any;


  constructor(private apiService: ApiService, public dialog: MatDialog,
    private router: Router, private toastr: ToastrService, public commonService: CommonService, private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.invoiceStatusForm = this.fb.group({
      id: [''],
      invoiceID: [''],
      eventId: [''],
      ratePerMSME: [''],
      noOfMSMEAttended: [''],
      gstType: [''],
      gstPercent: [''],      
      totalGST: [''],
      total: [''],
      finalTotal: [''],
      invoiceFileName: [''],
      invoiceFilePath: [''],
      invoiceAccepted: [''],      
      status: [''],
      eventName: [''],
      createdDate: [''],
      eventStatus: [''],
      intervention: [''],
      component: [''],
    });

    this.paymentDetailsForm = this.fb.group({
      paymentDate: ['', [Validators.required]],
      paymentMode: ['', [Validators.required]],
      utrNumber: ['', [Validators.required, Validators.pattern(this.commonService.nameWithHypenCommaSlash), Validators.minLength(5), Validators.maxLength(15)]],
      amount: ['', [Validators.required, Validators.pattern(this.commonService.numberPattern), Validators.minLength(2), Validators.maxLength(10)]],
      status: ['', [Validators.required]],
      statusName: [''],
    });
  }

  ngOnInit() {
    this.maxDate = new Date();
    this.LoadInvoiceStatusData();
    this.LoadStatusMaster();
    this.LoadPaymentMode();
    this.CheckIfPaymentDone();
    //this.LoadMSMEList();
  }

  //async LoadMSMEList(): Promise<void> {
  //  var dtoEventId = {
  //    EventId: this.eventId
  //  }
  //  this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIA, dtoEventId).subscribe(
  //    (result) => {
  //      if (result.status) {
  //        this.msmeList = result.data;
  //      }
  //    }
  //  );
  //}

  LoadInvoiceStatusData()
  {   
    var dtoEventId = {
      EventId: this.eventId,
      Mobile: this.mobile
    }
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETINVOICESTATUSDATAFORMSSIDC, dtoEventId).subscribe(
      (result) => {
        if (result.status) {
          this.invoiceStatusForm.disable();
          this.invoiceStatusForm.patchValue(result.data);
          this.unVerified = result.data.unverifiedMSME

          const invCreatedDate = new Date(result.data.date);
          const formattedCreatedDate = `${invCreatedDate.getFullYear()}-${(invCreatedDate.getMonth() + 1).toString().padStart(2, '0')}-${invCreatedDate.getDate().toString().padStart(2, '0')}`;
          this.invoiceStatusForm.get('createdDate')?.setValue(formattedCreatedDate);         
          //this.paymentDetailsForm.patchValue({
          //  status : result.data.status
          //})
        }
      }
    );
  }

  DisableonPending(status: any) {
    if (status.value === '3') {
      this.paymentDetailsForm.get('paymentDate')?.disable();
      this.paymentDetailsForm.get('paymentMode')?.disable();
      this.paymentDetailsForm.get('utrNumber')?.disable();
      this.paymentDetailsForm.get('amount')?.disable();
      this.showUpdate = true;
    } else {
      this.paymentDetailsForm.enable();
      this.showUpdate = false;
    }
  }

  CheckIfPaymentDone() {
    var dtoCheckPaymentStatus = {
      EventId: this.eventId,
      Mobile: this.mobile
    }
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.CHECKPAYMENTSTATUS,  dtoCheckPaymentStatus ).subscribe(
      (result) => {
        if (result.status && result.data.statusName === 'Payment Done') {
          this.showSection = false;
          this.paymentDetailsForm.patchValue({
            statusName : result.data.statusName
          });

          var dtoEventId = {
            EventId: this.eventId,
            Mobile: this.mobile
          }
          this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETPAYMENTDETAILS, dtoEventId).subscribe(
            (result) => {
              if (result.status) {
                this.paymentDetailsForm.disable();
                this.paymentDetailsForm.patchValue(result.data);
                const paymentDate = new Date(result.data.paymentDate);
                const formattedPayementDate = `${paymentDate.getFullYear()}-${(paymentDate.getMonth() + 1).toString().padStart(2, '0')}-${paymentDate.getDate().toString().padStart(2, '0')}`;
                this.paymentDetailsForm.get('paymentDate')?.setValue(formattedPayementDate);
              }
            }
          );
        } else if (result.status && result.data.statusName === 'Payment Pending') {
          this.paymentDetailsForm.get('paymentDate')?.disable();
          this.paymentDetailsForm.get('paymentMode')?.disable();
          this.paymentDetailsForm.get('utrNumber')?.disable();
          this.paymentDetailsForm.get('amount')?.disable();
          this.showSection = true;
          var dtoMSSIDCUser = {
            Mobile: this.mobile
          }
          this.paymentDetailsForm.patchValue(
            {
              status: result.data.status,
              statusName: result.data.statusName
            });
          this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETINVOICESTATUSMASTER, dtoMSSIDCUser).subscribe(
            (response) => {
              if (response.status) {
                this.statusList = response.data;

                // Assuming you want to remove the values with id '4' and '5' from the list
                const idsToRemove = ['1', '4', '5', '6', '7']; // Set the values you want to remove

                // Remove the unwanted options from the statusList
                this.statusList = this.statusList.filter(status => !idsToRemove.includes(status.id.toString()));

              }
            }
          );
        }
        else {
          this.showSection = true;
          var dtoMSSIDCUser = {
            Mobile: this.mobile
          }
          this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETINVOICESTATUSMASTER, dtoMSSIDCUser).subscribe(
            (result) => {
              if (result.status) {
                this.statusList = result.data;

                // Assuming you want to remove the values with id '4' and '5' from the list
                const idsToRemove = ['1','4', '5','6','7']; // Set the values you want to remove

                // Remove the unwanted options from the statusList
                this.statusList = this.statusList.filter(status => !idsToRemove.includes(status.id.toString()));

              }
            }
          );
        }

      }
    );
  }

  onReset() {
    this.paymentDetailsForm.reset();
    //window.location.reload();    
  }

  onBack() {
    this.router.navigate(['/invoicedashboardmssidc']);
  }

  LoadStatusMaster() {
    var dtoMSSIDCUser = {
      Mobile: this.mobile
    }
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETINVOICESTATUSMASTER, dtoMSSIDCUser).subscribe(
      (result) => {
        if (result.status) {
          this.statusList = result.data;
        }
      }
    );
  }

  LoadPaymentMode() {
    var dtoMSSIDCUser = {
      Mobile: this.mobile
    }
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETPAYMENTMODE, dtoMSSIDCUser).subscribe(
      (result) => {
        if (result.status) {
          this.paymentMode = result.data;
        }
      }
    );
  }

  onDownloadInvoice() {
    var filePath = this.invoiceStatusForm.get('invoiceFilePath')?.value;
    var fileName = this.invoiceStatusForm.get('invoiceFileName')?.value;
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onSubmit() {
    if (this.showUpdate) {
      var dtoUpdatePaymentStatusByMSSIDC = {
        invoiceID: this.invoiceStatusForm.get('invoiceID')?.value,
        status: this.paymentDetailsForm.get('status')?.value,
        mobile: this.mobile
      }
      this.apiService.postRequest(API_ENDPOINTS.MASTERS.INVOICE.UPDATEPAYMENTSTATUSBYMSSIDC, dtoUpdatePaymentStatusByMSSIDC).subscribe(
        (result) => {
          if (result.status) {
            this.toastr.success(result.message);
            window.location.reload();
          }
        }
      );
    } else {
      if (this.paymentDetailsForm.get('paymentDate')?.value) {
        var doc = this.paymentDetailsForm.get('paymentDate')?.value;
        const value = this.datePipe.transform(doc, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
        this.paymentDetailsForm.get('paymentDate')?.setValue(value);
      }

      if (this.paymentDetailsForm.valid) {
        var dtoInsertPaymentDetailsByMSSIDC = {
          invoiceID: this.invoiceStatusForm.get('invoiceID')?.value,
          paymentDate: this.paymentDetailsForm.get('paymentDate')?.value,
          paymentMode: this.paymentDetailsForm.get('paymentMode')?.value,
          utrNumber: this.paymentDetailsForm.get('utrNumber')?.value,
          amount: this.paymentDetailsForm.get('amount')?.value,
          status: this.paymentDetailsForm.get('status')?.value,
          mobile: this.mobile
        }
        this.apiService.postRequest(API_ENDPOINTS.MASTERS.INVOICE.INSERTPAYMENTDETAILSBYMSSIDC, dtoInsertPaymentDetailsByMSSIDC).subscribe(
          (result) => {
            if (result.status) {
              this.toastr.success(result.message);
              window.location.reload();
            }
          }
        );

      } else {
        this.paymentDetailsForm.markAllAsTouched();
        this.toastr.error("Form is invalid");
        return;
      }
    }    
  }

  blockManualInput(event: KeyboardEvent): void {
    event.preventDefault(); // Prevent keypresses (manual typing)
  }

  openFilePreviewDialog(): void {
    var filePath = this.invoiceStatusForm.get('invoiceFilePath')?.value;
    var fileName = this.invoiceStatusForm.get('invoiceFileName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIA, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.dataSource = data;
        this.adjustPaginator();
      });
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadData();
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  exportToExcel(): void {
    const fileName = 'MSME_Participant_List.xlsx';

    const DtoPagination = {
      EventId: this.eventId,
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
    };

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETMSMELISTFORIA, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data;

          if (!this.allrecord || this.allrecord.length === 0) {
            this.toastr.error('No data available to export.');
            return;
          }

          // 👇 Match table columns
          const excelData = this.allrecord.map((item, index) => ({
            'Sr.No': item.rowNum,
            'Udyam Registration Number': item.udyamRegistrationNumber,
            'Participant Name': item.participantName,
            'Designation': item.designation,
            'Mobile Number': item.mobileNumber,
            'Email ID': item.emailId,
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          // Adjust widths as per content
          const columnWidths = [
            { wch: 8 },  // Sr.No
            { wch: 25 }, // Udyam Registration Number
            { wch: 25 }, // Participant Name
            { wch: 20 }, // Designation
            { wch: 18 }, // Mobile Number
            { wch: 30 }, // Email ID
          ];
          worksheet['!cols'] = columnWidths;

          const workbook: XLSX.WorkBook = {
            Sheets: { 'Participant List': worksheet },
            SheetNames: ['Participant List'],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });

          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastr.success('Excel exported successfully!');
        }
      }
    );
  }




  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

}
